import * as React from "react";

function ArrowTrendDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M466.7 352 320 205.3 214.6 310.6c-12.5 12.5-32.7 12.5-45.2 0L9.372 150.6c-12.496-12.5-12.496-32.7 0-45.2 12.498-12.52 32.758-12.52 45.258 0L191.1 242.7l106.3-105.3c12.5-12.5 32.7-12.5 45.2 0L512 306.7v-83.6c0-16.8 14.3-32 32-32s32 15.2 32 32V384c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h82.7z"
  }));
}

const ForwardRef = React.forwardRef(ArrowTrendDownIcon);
export default ForwardRef;